export default {
  'Screenshot': '스크린샷',
}